import styles from './index.less';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hubspotLoginReferralFormSelector } from 'src/selector/hubspotform';
import { closeLoginReferralForm } from 'src/actions/hubspotform';

export default function HubspotChowbusReferralForm() {
  const dispatch = useDispatch();

  const { shown } = useSelector(hubspotLoginReferralFormSelector);
  const hs_form_frame_ref = useRef();

  const onCloseHubspotPopup = () => {
    console.log('onCloseHubspotPopup');
    dispatch(closeLoginReferralForm());
  };

  return (
    <React.Fragment>
      {
        <div className={styles.hubspotPopupOverlay} style={!shown ? { display: 'none' } : {}}>
          <div className={styles.hubspotpopup}>
            <div className={styles.hubspotpopupMain}>
              <div className={styles.closeWrapper}>
                <div className={styles.closeIcon} onClick={onCloseHubspotPopup} />
              </div>
              <div
                ref={hs_form_frame_ref}
                className={'hs-form-frame'}
                data-region="na1"
                data-form-id="e70c3879-fd0f-457e-bf31-c3153c653e40"
                data-portal-id="47969074"
              />
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  );
}
